/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Logger from "../lib/logger";
import ThemeHeader from "./partials/ThemeHeader";
import ThemeMobileHeader from "./partials/ThemeMobileHeader";

// Import jQuery - required by Ninja Forms
import jQuery from "jquery";
window.jQuery = window.$ = jQuery;

export default function () {
    const NAME = 'Global';
    Logger.info(`${NAME} > loading`);

    // Vars
    // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

    const headerDom = document.querySelector(`[data-theme-header]`);
    const mobileHeaderDom = document.querySelector(`[data-theme-mobile-header]`);

    // Logic
    // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

    /**
     * init --- Initialization block
     */
    function init() {
        Logger.info(`${NAME} > init`);
        initHeader();
        initCustomCTA();

        return {
            util: {
                stopBodyScrolling: stopBodyScrolling
            }
        }
    }

    /**
     * initHeader --- Initialize the header
     */
    function initHeader() {
        Logger.info(`${NAME} > initHeader`);
        if (headerDom) {
            const header = new ThemeHeader(headerDom);
            header.init();
            header.on(`ThemeHeader:search_toggled`, (isOpen) => {
                if (isOpen) {
                    window.scrollTo(0, 0);
                    stopBodyScrolling(true);
                } else {
                    stopBodyScrolling(false);
                }
            });
        }
        if (mobileHeaderDom) {
            const mobileHeader = new ThemeMobileHeader(mobileHeaderDom);
            mobileHeader.init();
            mobileHeader.on(`ThemeMobileHeader:mobile_checkbox_changed`, (data) => {
                if (data.checked) {
                    stopBodyScrolling(true);
                } else {
                    stopBodyScrolling(false);
                }
            });
        }
    }

 /**
 * initCustomCTA --- Initialize the custom CTA functionality
 */
function initCustomCTA() {
	Logger.info(`${NAME} > initCustomCTA`);

	// Use a more reliable event binding method
	document.addEventListener('click', function(e) {
			// Check if the click occurred on or inside a CTA wrapper
			const ctaWrapper = e.target.closest('.custom-cta-wrapper');

			// If we found a wrapper and the click wasn't on the link itself
			if (ctaWrapper && !e.target.closest('a')) {
					Logger.info(`${NAME} > CTA click detected`);
					const url = ctaWrapper.getAttribute('data-url');

					// Navigate to the URL if it exists
					if (url) {
							window.location.href = url;
					}
			}
	});

	// Set cursor to pointer for all CTA wrappers
	const ctaWrappers = document.querySelectorAll('.custom-cta-wrapper');
	ctaWrappers.forEach(function(wrapper) {
			wrapper.style.cursor = 'pointer';
	});
}

    /**
     * Stop the body from scrolling
     */
    function stopBodyScrolling(bool) {
        Logger.info(`${NAME} > stopBodyScrolling`);
        if (bool === true) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }

    // Do not edit below this line...
    // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
    Logger.info(`${NAME} > loaded`);

    return init();
}
